const filterOrigin = (array) => {
  let map = {}
  array.forEach((item) => {
    map[JSON.stringify(item)] = item
  })
  return Object.values(map)
}
export {
  filterOrigin
}
